export const MOVE_GROUP_MODAL_ID = 'move-group-modal-id';
